import PaytoIcon from 'assets/icons/payments/payto-icon-2.svg';
import withAddPaytoAccountsAgreement from 'features/to/HOCs/payment/withAddPaytoAccountsAgreement';
import { isFunction } from 'lodash';
import React from 'react';
import Popup from './popup';

const PaytoErrorCodePopup = withAddPaytoAccountsAgreement(Popup);

const PaytoErrorCodeModal = ({
  isShow,
  action,
  errorData,
  title,
  content,
  buttonLabel2,
  modalOptions,
  modalData,
}) => {
  const handleOnClick = () => {
    if (isFunction(action)) {
      action();
    }
  };

  return (
    <PaytoErrorCodePopup
      isOpen={isShow}
      imageSrc={PaytoIcon}
      imagesStyles={{
        width: '75px',
        height: '60px',
        objectFit: 'cover',
      }}
      alignContent="center"
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      errorData={errorData}
      title={title}
      content={content}
      buttonLabel2={buttonLabel2}
      modalOptions={modalOptions}
      modalData={modalData}
    />
  );
};

export default PaytoErrorCodeModal;
